import React, {useEffect, useState} from 'react';
import { NoticeInfoDTO } from '../../../../interface/model/board';
import Api from "../../../../interface/api/content";

export default function Notice() {
    const siteInfo = JSON.parse(localStorage.getItem('siteInfo'));
    const [ selectedNoticeInfo, setSelectedNoticeInfo ] = useState<NoticeInfoDTO>(null);
    const [ noticeInfos, setNoticeInfos ] = useState<Array<NoticeInfoDTO>>([]);

    function modeHandler(boardInfo) {
        setSelectedNoticeInfo(boardInfo);
    }

    function selectBoardHandler(boardInfo) {
        if( boardInfo.seq !== null ) Api.getSelectBoardInfo(boardInfo.seq).then(res => setSelectedNoticeInfo(res.data));
    }

    useEffect(() => {
        Api.getBoardInfos("BOARD", siteInfo.seq).then(res => setNoticeInfos(res.data));
    }, [])

    return (
        <div className={'nv_contents'}>
            {
                selectedNoticeInfo !== null ?
                    <>
                        <Detail selectedNoticeInfo={selectedNoticeInfo}
                        />
                        <div className="nv_btn_area">
                            <button type="button" className="nv_btn_black" onClick={() => modeHandler(null)}>목록으로</button>
                        </div>
                    </> :
                    <>
                        <List noticeInfos={noticeInfos}
                            selectBoardHandler={selectBoardHandler}
                        />
                    </>                
            }
            
        </div>
    )
}

function List({noticeInfos, selectBoardHandler}) {
    return(
        <>
            <h2 className="nv_subtit">공지사항</h2>
            <div className="nv_board_notice">
                <div className="nv_tablebox">
                    <div className="board_search_area">
                        <div className="nv_select_box">
                            <p>제목+내용</p>
                            <ul className="nv_select">
                                <li>제목+내용</li>
                                <li>제목</li>
                                <li>내용</li>
                            </ul>
                        </div>
                        <div className="board_search_input">
                            <input type="text" className="nv_input" />
                            <input type="submit" className="search_icon" />
                        </div>
                    </div>
                    <table className="nv_table textcenter board">
                        <thead>
                            <tr>
                                <th className="num">No.</th>
                                <th className="title">제목</th>
                                <th className="date">등록일</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                noticeInfos.map((noticeInfo, index) => (
                                    <tr key={`noticeInfoKey-${index}`}>
                                        <td>{index+1}</td>
                                        <td className="title"
                                            onClick={() => selectBoardHandler(noticeInfo)}
                                        >{noticeInfo.title}</td>
                                        <td>{noticeInfo.createDate.substring(0,10)}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                    <div className="pagenum_area">
                        <ul>
                            <li className="first">fisrt</li>
                            <li className="prev">prev</li>
                            <li className="on">1</li>
                            {/*<li>2</li>*/}
                            {/*<li>3</li>*/}
                            {/*<li>4</li>*/}
                            {/*<li>5</li>*/}
                            {/*<li>6</li>*/}
                            {/*<li>7</li>*/}
                            {/*<li>8</li>*/}
                            {/*<li>9</li>*/}
                            {/*<li>0</li>*/}
                            <li className="next">next</li>
                            <li className="last">last</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

function Detail({selectedNoticeInfo}) {
    return(
        <>
            <h2 className="nv_subtit">공지사항</h2>
            <div className="nv_board_notice">
                <div className="nv_tablebox">
                    <table className="nv_table textcenter write">
                        <tbody>
                                    <tr>
                                        <td className="tit">제목</td>
                                        <td className="textleft">{selectedNoticeInfo.title}</td>
                                    </tr>
                                    <tr>
                                        <td className="tit">내용</td>
                                        <td className="textleft" dangerouslySetInnerHTML={ {__html: selectedNoticeInfo.contents} }></td>
                                    </tr>
                                    <tr>
                                        <td className="tit">첨부파일</td>
                                        {
                                            selectedNoticeInfo.fileInfo !== null ?
                                                <td className="textleft">{selectedNoticeInfo.fileInfo.fileName}</td> : 
                                                <td className="textleft"></td>
                                        }
                                    </tr>
                                
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}